import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { color } from "chart.js/helpers";
import { formatDate } from "../constants/FormateDate";
import { Link } from "react-router-dom";

const ExpiredSoonModal = ({
  expiredSoonModalVisible,
  setExpiredSoonModalVisible,
  subscriptionExpiryDate,
}) => {
  const handleModalClose = () => {
    setExpiredSoonModalVisible(!expiredSoonModalVisible);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={expiredSoonModalVisible}
        style={{ width: "40vw" }}
        onHide={() => {
          if (!expiredSoonModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div className="flex-1">
             
              <div style={{ position: "absolute", right: 0 }}>
                <Button
                  label="x"
                  onClick={(e) => hide(e)}
                  text
                  className=" text-2xl"
                  style={{ color: "red" }}
                ></Button>
              </div>
            

            <div>
              <div
                className="surface-0  pl-4 py-2 border-bottom-1"
                style={{
                  "--border-radius": "50px",
                  "--surface-0": "#F1F7FF",
                  borderBottomColor: "#D2DBD6",
                }}
              >
                <div className="flex justify-content-center align-items-center">
                  <img
                    src={"images/time-management.png"}
                    style={{ width: 175 }}
                  />
                </div>
                <div className="flex justify-content-center align-items-center">
                  <img
                    src={
                      "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                    }
                    style={{  marginRight: 10 }}
                  />
                  <p className="text-xl font-medium">
                   Your Subscription Is Set To Expire Soon!
                  </p>
                </div>
                <div className="flex justify-content-center align-items-center">
                  <img
                    src={
                      "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                    }
                    style={{   marginRight: 10 }}
                  />
                  <p className="text-xl font-medium">
                    Kindly Re-new Your Subscription
                  </p>
                </div>
                <div className="flex justify-content-center align-items-center">
                  <img
                    src={
                      "images/hourglass.png"
                    }
                    style={{  width:20, marginRight: 10 }}
                  />
                  <p className="text-xl font-medium">
                    Due Date 
                    <span style={{ color: "#1752AA" }}>
                      {" "}
                      {formatDate(subscriptionExpiryDate)}
                    </span>
                  </p>
                </div>
                <div className="flex justify-content-center align-items-center">
                  <p className="text-sm font-medium">
                    For Data Retention and Deletion Policy, Please refer
                  </p>
                </div>
                <div className="flex justify-content-center align-items-center">
                  <p className="text-sm font-medium">
                     <Link
                      to="https://www.oneindiatech.com/?page_id=3"
                      target="_blank"
                      style={{
                        color: "#0066a6",
                        fontSize: 14,
                        fontWeight: 400,
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                    >
                      Privacy Policy
                    </Link> - <Link
                      to="https://www.oneindiatech.com/?page_id=1080"
                      target="_blank"
                      style={{
                        color: "#0066a6",
                        fontSize: 14,
                        fontWeight: 400,
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                    >
                      Term & Condition
                    </Link>
                  </p>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default ExpiredSoonModal;
